import { render, staticRenderFns } from "./step-loading.vue?vue&type=template&id=18240822&scoped=true&"
import script from "./step-loading.vue?vue&type=script&lang=js&"
export * from "./step-loading.vue?vue&type=script&lang=js&"
import style0 from "./step-loading.vue?vue&type=style&index=0&id=18240822&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18240822",
  null
  
)

export default component.exports